import { getNextOrders } from '@front/common/endpoints'
import { NextOrder } from '@front/common/types'
import { computed } from '@vue/composition-api'
import { useStore } from '@vueblocks/vue-use-vuex'

import useApiState from '@member-area/core/hooks/useApiState'
import useAuth from '@member-area/middleware/auth.hook'

import { INSERT_NEXT_ORDER } from './constants'

export default function useNextOrders() {
  const store = useStore()
  const { auth } = useAuth()

  const [
    _onFetchOrdersSuccess,
    fetchNextOrdersState,
    fetchNextOrdersAction,
  ]: any = useApiState(getNextOrders)

  const nextOrders = computed<NextOrder[]>(() => {
    return store.getters['nextOrder/get']
  })

  async function fetchNextOrders() {
    const { data } = await fetchNextOrdersAction(auth.value.id)

    store.commit(INSERT_NEXT_ORDER, data)
  }

  return {
    nextOrders,
    fetchNextOrdersState,
    fetchNextOrders,
  }
}
